module.exports = __webpack_public_path__ + "static/customer-116a92f2c42c555d93f0187a67f2d9cd.png";